import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILogin } from "types";

const initialState = {
	isAuthenticated: false,
	error: null,
	email: "",
	password: "",
};

export const LoginState = createSlice({
	name: "login",
	initialState,
	reducers: {
		setLogin(
			state: ILogin,
			action: PayloadAction<{
				email: string;
				name: string;
				password: string;
				isAuthenticated: boolean;
				label?: string;
			}>
		) {
			state.isAuthenticated = action.payload.isAuthenticated;
			state.password = action.payload.password;
			state.email = action.payload.email;
			state.label = action.payload.label;
			state.name = action.payload.name;
		},
		setIsAuthenticated(state: ILogin, action: PayloadAction<boolean>) {
			state.isAuthenticated = action.payload;
		},
	},
});

export const { setLogin, setIsAuthenticated } = LoginState.actions;

export default LoginState.reducer;
